import { Input } from "components/Form/components/Input/Input";
import { FormComponentProps } from "../FormComponentProps";
import { CopyToClipboard } from "./CopyToClipboard";

export type CopyToClipboardFormComponentProps = {};

export const CopyToClipboardConditionalFormComponent = ({
    input,
    meta,
    fieldProps,
    fieldAttr,
}: FormComponentProps) => {
    const textToCopy = input.value ?? "";

    return textToCopy.length ? (
        <Input fieldProps={fieldProps} fieldAttr={fieldAttr} input={input} meta={meta}>
            <CopyToClipboard
                textToCopy={textToCopy}
                identifier={input.name}
                input={input}
                attributes={fieldAttr}
                isReadonly={true}
            />
        </Input>
    ) : null;
};
